import "core-js/modules/es.function.name";
import "core-js/modules/es.object.define-property";
import { dateOffset, dateParse, serverDateNow } from '@/lib/utils';

var ParticipationCertificateModel =
/** @class */
function () {
  function ParticipationCertificateModel(raw) {
    this.activityId = raw.activity_id;
    this.cover = raw.cover;
    this.name = raw.name;
    this.sign_up_start_date = raw.sign_up_start_date;
    this.sign_up_finish_date = raw.sign_up_finish_date;
    this.start_date = raw.start_date;
    this.finish_date = raw.finish_date;
    this.level = raw.level;
    this.finished = raw.finished;
    this.certs = raw.certs || [];
    this.count = raw.count || 0;
  }

  Object.defineProperty(ParticipationCertificateModel.prototype, "startParticipation", {
    /** 是否开始报名 */
    get: function get() {
      var timestamp = serverDateNow().valueOf();
      return timestamp >= dateParse(this.sign_up_start_date).valueOf();
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ParticipationCertificateModel.prototype, "closeParticipation", {
    /** 是否结束报名 */
    get: function get() {
      var timestamp = serverDateNow().valueOf();
      return timestamp >= dateOffset(dateParse(this.sign_up_finish_date), 1).valueOf();
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ParticipationCertificateModel.prototype, "startSignIn", {
    /** 是否开始打卡 */
    get: function get() {
      var timestamp = serverDateNow().valueOf();
      return timestamp >= dateParse(this.start_date).valueOf();
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ParticipationCertificateModel.prototype, "closeSignIn", {
    /** 是否结束打卡 */
    get: function get() {
      var timestamp = serverDateNow().valueOf();
      return timestamp >= dateOffset(dateParse(this.finish_date), 1).valueOf();
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ParticipationCertificateModel.prototype, "tag", {
    /** 标签文本 */
    get: function get() {
      if (!this.startParticipation) {
        return '未开始';
      } else if (!this.closeParticipation && !this.startSignIn) {
        return '报名中';
      } else if (this.startSignIn && !this.closeSignIn) {
        return '进行中';
      } else if (this.closeSignIn) {
        return '已结束';
      }
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ParticipationCertificateModel.prototype, "isFinish", {
    /** 是否完赛 */
    get: function get() {
      return this.finished;
    },
    enumerable: false,
    configurable: true
  });
  return ParticipationCertificateModel;
}();

export { ParticipationCertificateModel };